import React from "react";
import "../style/QuickRide.css";
// import HeroImage from "../assets/RideShareHero.png";
// import carImage from "../assets/CarSliding.mp4";
import {
  FaWallet,
  FaLeaf,
  FaShieldAlt,
  FaClock,
  FaUsers,
  FaCheckCircle,
} from "react-icons/fa";
import { useState } from "react";

const Ridesharing: React.FC = () => {
  const [activeFeature, setActiveFeature] = useState<string | null>(null);

  const handleFeatureClick = (feature: string) => {
    setActiveFeature(activeFeature === feature ? null : feature);
  };

  return (
    <div className="ridesharing-page">
      {/* <div className="hero-section">
        <img
          src={HeroImage}
          alt="Ridesharing Hero"
          className="hero-image-two"
        />
        <video autoPlay muted loop className="moving-car">
          <source src={carImage} type="video/mp4" />
        </video>
      </div> */}
      <div className="hero-section">
        <h1>Ridesharing Made Easy</h1>
        <p>Connect with fellow travelers and enjoy a cost-effective commute.</p>
      </div>

      <div className="benefits-grid">
        <div
          className="benefit-card"
          onClick={() => handleFeatureClick("cost")}
        >
          <FaWallet className="benefit-icon" />
          <h3>Cost-Effective</h3>
          <p>Split travel costs and save money on your daily commute</p>
          {activeFeature === "cost" && (
            <div className="feature-details">
              <p>
                By sharing rides, you can significantly reduce your travel
                expenses.
              </p>
            </div>
          )}
        </div>

        <div className="benefit-card" onClick={() => handleFeatureClick("eco")}>
          <FaLeaf className="benefit-icon" />
          <h3>Eco-Friendly</h3>
          <p>Reduce carbon emissions by sharing rides with others</p>
          {activeFeature === "eco" && (
            <div className="feature-details">
              <p>
                Join the movement towards sustainable travel and help the
                environment.
              </p>
            </div>
          )}
        </div>

        <div
          className="benefit-card"
          onClick={() => handleFeatureClick("safe")}
        >
          <FaShieldAlt className="benefit-icon" />
          <h3>Safe & Secure</h3>
          <p>Verified users and secure payment systems</p>
          {activeFeature === "safe" && (
            <div className="feature-details">
              <p>
                Your safety is our priority. All users are verified for a secure
                experience.
              </p>
            </div>
          )}
        </div>
      </div>

      <div className="highlighted-features">
        <h2>Why Choose Ridesharing?</h2>
        <div className="highlight-card">
          <FaClock className="highlight-icon" />
          <h3>Flexible Scheduling</h3>
          <p>Choose rides that match your daily routine</p>
        </div>

        <div className="highlight-card">
          <FaUsers className="highlight-icon" />
          <h3>Community Driven</h3>
          <p>Join a network of trusted commuters</p>
        </div>

        <div className="highlight-card">
          <FaCheckCircle className="highlight-icon" />
          <h3>Easy to Use</h3>
          <p>Simple booking and ride management</p>
        </div>
      </div>
    </div>
  );
};

export default Ridesharing;
